import { createSelector } from 'reselect';

import * as types from '../actions/actionTypes';
import { getActiveSewpat } from './sewpats';

export default (state, action) => {
    switch (action.type) {

        case types.UI_SWATCH_SELECTED:
            return Object.assign(
                {},
                state,
                {
                    activeColorSwatch: parseInt(action.id, 10),
                    displayColorpicker: true,
                },
            );

        case types.UI_PICKER_HIDED:
            return Object.assign(
                {},
                state,
                {
                    activeColorSwatch: null,
                    displayColorpicker: false,
                },
            );

        case types.UI_COLOR_INPUT_FOCUS_TOGGLED:
            return Object.assign(
                {},
                state,
                { colorInputHasFocus: action.bool },
            );

        case types.ACTIVE_BREAKPOINT_CHANGED:
            const max = Math.floor((
                action.breakpointData.min - (
                    action.breakpointData.fontSize * 7
                )
            ) / (
                (
                    action.breakpointData.fontSize * 6.85
                ) +
                (
                    action.breakpointData.fontSize * 0.31
                )
            ));
            const number = Math.max(3, max);
            return Object.assign({}, state, { swatchesToShow: number });

        case types.SHOW_ALL_SWATCHES_SELECTED:
            return Object.assign({}, state, { showAllSwatches: action.bool });

        case types.NAVIGATED_TO_SINGLE_PATTERN_VIEW:
        case types.SLIDER_HUE_CHANGED:
        case types.SLIDER_LIGHTNESS_CHANGED:
        case types.SLIDER_SATURATION_CHANGED:
        case types.COLOR_CHANGED:
        case types.SHOW_RECOLORING_LOADER:
            return Object.assign({}, state, { showRecoloringLoader: true });

        case types.HIDE_RECOLORING_LOADER:
        case types.COLORS_RECEIVED:
        case types.COLORS_RESETTED:
            return Object.assign({}, state, { showRecoloringLoader: false });

        case types.COLOR_SLIDER_RESETTED:
            return Object.assign({}, state, { resetSliders: action.bool });

        case types.UI_TOGGLE_FIGURINE_PREVIEW:
            return Object.assign(
                {},
                state,
                { showFigurinePreview: !state.showFigurinePreview },
            );

        case (
            action.type.match(/NAVIGATED/) || {}
        ).input:
            return Object.assign({}, state, { showAllSwatches: false });

        default:
            return state;
    }
};

export const getShouldSliderReset =
    state => state.stolo.ui.recoloring.resetSliders;
const getThumbnailBase = state => state.stolo.ui.recoloring.thumbnailBase;

export const getPreviewRepeats = createSelector(
    [getThumbnailBase, getActiveSewpat],
    (base, sewpat) => (
        {
            col: 3,
            rows: (
                Math.ceil((
                    sewpat.galleryOverlay.height / sewpat.galleryOverlay.width
                ) * 3)
            ),
        }
    ),
);

export const getShowRecoloringLoader =
    state => state.stolo.ui.recoloring.showRecoloringLoader;

export const showFigurinePreview =
    state => state.stolo.ui.recoloring.showFigurinePreview;



// WEBPACK FOOTER //
// ./src/reducers/ui.recoloring.js